/**
 * 목록을 CSV 로 — 보이는 대로(필터·정렬을 그대로) 내려받는다.
 *
 * 리포트·활동 로그는 서버가 CSV 를 만든다(기간 전체를 자르지 않고). 화면 목록은 콘솔이 이미 모두 받아
 * 들고 있고, 사람이 원하는 것은 "지금 걸러 본 그 목록" 이라 브라우저에서 만든다 — 현장 점검표·자산
 * 대장에 붙여 쓰는 용도다.
 */

/**
 * 한 칸. 쉼표·따옴표·줄바꿈이 있으면 따옴표로 감싼다(RFC 4180).
 *
 * **수식처럼 시작하는 값은 앞에 작은따옴표를 붙인다.** 화면 이름을 `=HYPERLINK(...)` 로 지어 두면 엑셀이
 * 열자마자 수식으로 실행한다(CSV 수식 주입). 값은 사람이 콘솔에 적은 글이라 막아야 한다.
 */
export function csvCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  // 숫자는 사람이 적은 글이 아니다 — 음수도 그대로 둔다.
  if (typeof value === 'number') return String(value);
  let text = value;
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** 머리줄과 줄들 → CSV 글. 엑셀이 한글을 읽도록 맨 앞에 BOM 을 붙인다(서버 CSV 와 같다). */
export function toCsv(header: readonly string[], rows: ReadonlyArray<ReadonlyArray<string | number | null>>): string {
  const lines = [header, ...rows].map((row) => row.map(csvCell).join(','));
  return `﻿${lines.join('\r\n')}\r\n`;
}

/** 브라우저에서 파일로 내려받게 한다. */
export function downloadText(filename: string, content: string, type = 'text/csv;charset=utf-8'): void {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // 내려받기가 시작된 뒤에 놓는다 — 바로 놓으면 일부 브라우저가 빈 파일을 받는다.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
